import { render, staticRenderFns } from "./WelcomePanel.vue?vue&type=template&id=4db9ef3f&"
import script from "./WelcomePanel.vue?vue&type=script&lang=js&"
export * from "./WelcomePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports